export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Leave</title>
    <path
      d="M15.9 5h13v22h-13M9.95 11 5 15.95l4.95 4.95M5 15.95l15.9.05"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
